export function getAssetTypeFromFile(file) {
  const extension = file.name.split('.').pop().toLowerCase();

  // Image files
  if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(extension)) {
    return 'image';
  }

  // Video files
  if (['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv'].includes(extension)) {
    return 'video';
  }

  // 3D model files
  if (['obj', 'fbx', 'gltf', 'glb', 'dae', '3ds', 'ply'].includes(extension)) {
    return 'scene';
  }

  return 'file';
}
